'use client';

import * as React from 'react';

/**
 * Provides an explicit DOM container for Radix UI portals (Select dropdown,
 * Dialog overlay, etc.). When null, portals fall back to document.body.
 *
 * Set this to an element marked with `data-de-portal` so that portaled
 * content is rendered inside the scoped CSS boundary and inherits styles
 * from the `[data-de-portal]` selector scope in the compiled stylesheet.
 */
const PortalContainerContext = React.createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

export function usePortalContainer(): HTMLElement | undefined {
  const container = React.useContext(PortalContainerContext);
  return container ?? undefined;
}
